import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { useAllHeyLightProducts } from "./useAllHeyLightProducts.ts";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { AdminHeyLightProductTable } from "./AdminHeyLightProductTable.tsx";
import { PrimaryButton } from "@normasteaching/norma-ui";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router";
import { CreateHeyLightProductScreenPath } from "./CreateHeyLightProductScreen.tsx";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";
import { ErrorState } from "../../UI/ErrorState.tsx";

export const AdminHeyLightAllProductScreenPath = "/admin/heylight/all-products";
export function AdminHeyLightAllProductScreen() {
  const { products, isLoading, error } = useAllHeyLightProducts();
  const navigate = useNavigate();
  if (isLoading) return <FullPageLoading />;
  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className={"flex-1 p-4 flex flex-col gap-4"}>
          <div
            className={
              "flex items-center justify-between gap-2 md:flex-row flex-col"
            }
          >
            <h1 className={"font-bold text-3xl flex-1"}>Prodotti HeyLight</h1>
            <div>
              <PrimaryButton
                iconRight={<Plus className={"w-5"} />}
                label={"Nuovo prodotto"}
                onClick={() => navigate(CreateHeyLightProductScreenPath)}
              />
            </div>
          </div>
          {error && <ErrorState />}
          <div className={"overflow-x-auto"}>
            <AdminHeyLightProductTable products={products} />
          </div>
        </div>
      </AdminMainContainer>

      <Footer />
    </Layout>
  );
}
